import gql from 'graphql-tag';

export const ModalSidebarListingFragment = gql`
  fragment ModalSidebarListingFragment on Listing {
    _id
    id
    title
    slug
    condition {
      displayName
    }
    images(input: { transform: "card_square" }) {
      source
    }
  }
`;
